'use client';

import { useEffect, useState } from 'react';

export function useFadeOutOnScroll(startOffset: number, endOffset: number) {
  const [opacity, setOpacity] = useState(1); // Initially, fully visible

  useEffect(() => {
    const handleScroll = () => {
      const container = document.documentElement;
      const scrollPosition = container.scrollTop + window.innerHeight; // How far down the page we are
      const containerHeight = container.scrollHeight;

      const offsetFromBottom = containerHeight - scrollPosition; // Distance from the bottom of the page

      if (offsetFromBottom >= endOffset) {
        setOpacity(1); // Fully visible until the scroll reaches the endOffset
      } else if (offsetFromBottom <= startOffset) {
        setOpacity(0); // Fully hidden past the startOffset
      } else {
        const progress = (offsetFromBottom - startOffset) / (endOffset - startOffset);
        setOpacity(progress); // Gradually reduce opacity based on scroll position
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [startOffset, endOffset]);

  return opacity;
}
